import { api } from "./client";

export interface Report {
  id: number;
  reporter_id: number;
  reported_user_id: number;
  reason: string;
  details: string | null;
  status: string;
  created_at: string;
  resolved_at: string | null;
}

export async function createReport(payload: { reported_user_id: number; reason: string; details?: string }): Promise<Report> {
  return api<Report>("/reports", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function fetchMyReports(limit = 20): Promise<Report[]> {
  return api<Report[]>(`/reports/me?limit=${limit}`);
}
